import React from "react";
import { useRoutes } from "routes/useRoutes";
import { useTranslation } from "shared/i18n/useTranslation";
import { useSurveyForm, useUnitsForm } from "./helpers/useSurveyForm";
import { SurveyFormContainer } from "./SurveyFormContainer";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faPencil } from "@fortawesome/free-solid-svg-icons";

export function Units() {
  const { translate } = useTranslation();
  const { survey, saveSurvey, isSubmitting } = useSurveyForm();
  const { onDeleteUnit } = useUnitsForm();
  const { goToEditUnits } = useRoutes();

  async function handleAddUnit(e: React.SyntheticEvent) {
    e.preventDefault();
    await saveSurvey();
    if (!survey.id)
      throw new Error("SurveyId can't be empty when trying to add unit");
    goToEditUnits(survey.id);
  }

  async function handleEditUnit(unitIndexToEdit: number) {
    const newSurvey = await saveSurvey();
    if (!newSurvey.id)
      throw new Error("SurveyId can't be empty when trying to add unit");
    goToEditUnits(newSurvey.id, newSurvey.units[unitIndexToEdit].id);
  }

  async function handleDeleteUnit(unitIndexToDelete: number) {
    onDeleteUnit(unitIndexToDelete);
  }

  return (
    <div className="mt-3">
      {translate("__units")}
      {survey.units.map((unit, index) => {
        return (
          <SurveyFormContainer
            key={`unit-${index}-${unit.id}`}
            className="p-2 mt-3"
          >
            <div>
              <span>RTU</span> {unit.rtu}
            </div>
            <div>
              <span>Model:</span> {unit.modelNumber}
            </div>
            <div>
              <span>Serial:</span> {unit.serialNumber}
            </div>
            <div className="mt-2">
              <button
                className="btn btn-outline-secondary"
                disabled={isSubmitting}
                onClick={(e) => {
                  e.preventDefault();
                  handleEditUnit(index);
                }}
              >
                <FontAwesomeIcon icon={faPencil} />
                {isSubmitting && (
                  <span
                    className="spinner-border spinner-border-sm ms-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>

              <button
                className="btn btn-outline-secondary ms-2"
                disabled={isSubmitting}
                onClick={(e) => {
                  e.preventDefault();
                  handleDeleteUnit(index);
                }}
              >
                <FontAwesomeIcon icon={faTrashCan} />

                {isSubmitting && (
                  <span
                    className="spinner-border spinner-border-sm ms-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                )}
              </button>
            </div>
          </SurveyFormContainer>
        );
      })}

      <div>
        <button
          className="btn btn-outline-primary mt-2"
          disabled={isSubmitting}
          onClick={handleAddUnit}
        >
          + Add Unit
        </button>
      </div>
    </div>
  );
}
